<template>
  <section id="ancaim-view">
    <template v-if="authUser && session && authUser.id === session.tutor_id">
      <v-container fluid v-if="session.mock">
        <v-card>
          <v-toolbar dense dark color="primary">
            Candidate instructions
            <v-spacer/>
            <v-btn icon @click="show_instruction = !show_instruction">
              <v-icon v-if="show_instruction">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar>

          <v-sheet class="overflow-y-auto" max-height="500px">
            <v-card-text class="ql-editor" v-if="session.mock.instruction && show_instruction" v-html="session.mock.instruction.body"></v-card-text>
          </v-sheet>

        </v-card>
      </v-container>

      <v-container fluid class="pt-0">
        <v-row>
          <v-col cols="12" md="5">
            <v-card>
              <v-toolbar dense>Candidate's answer</v-toolbar>
              <v-divider/>
              <v-sheet v-if="answers.length > 0" class="overflow-y-auto" max-height="600px">
                <!--                TODO check answer type-->
                <!--                <v-img class="mx-3" v-for="(answer, idx) in answers" :key="idx"-->
                <!--                       :src="`data:image/${answer.type};base64,${answer.file}`" />-->

                <v-card tile v-for="(item, idx) in answers" :key="idx">
                  <AnswerPreview :answer="item"></AnswerPreview>
<!--                  <template v-if="item.type === 'jpg'|| item.type === 'jpeg' || item.type === 'jpg'">-->
<!--                    <v-img :src="`data:image/${item.type};base64,${item.file}`" width="100%"/>-->
<!--                  </template>-->
<!--                  <template v-else-if="item.type === 'image/jpeg'|| item.type === 'image/png'">-->
<!--                    <v-img :src="`data:image/${item.type};base64,${item.file}`" width="100%"/>-->
<!--                  </template>-->
<!--                  <template v-else-if="item.type === 'application/pdf'">-->
<!--                    <embed :type="item.type" :src="toBlobUrl(item.file)" width="100%" height="500px">-->
<!--                  </template>-->
<!--                  <template v-else>-->
<!--                    <embed :type="item.type" :src="`data:${item.type};base64,${item.file}`" width="100%" height="500px">-->
<!--                  </template>-->
                </v-card>
              </v-sheet>
              <v-sheet v-else >
                <v-subheader class="text-center">No data available</v-subheader>
              </v-sheet>
            </v-card>
          </v-col>
          <v-col cols="12" md="7">
            <PDFEditor v-if="session_response && session_response.marking_layout"
                       :src="session_response.marking_layout"
                       :upload_url="`api/user/sessions/${$route.params.session_id}/response`"
            ></PDFEditor>

            <v-card class="mt-4">
              <v-btn v-if="session_response && session_response.marking_layout" download="marking_layout"
                     :href="`data:application/pdf;base64,${session_response.marking_layout}`"
              >
                Download template
              </v-btn>

              <v-btn @click="generateSessionResponse">rebuild template</v-btn>

              <v-divider/>
              <v-card-text v-if="session_response">
                <file-uploader :upload_url="`api/user/sessions/${$route.params.session_id}/response`"
                               :accept="'application/pdf'"
                               placeholder="Upload marked template"
                               @uploaded="updateSessionResponse"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid v-if="session.mock && session.mock.materials">
        <materials-viewer :items="session.mock.materials"></materials-viewer>
      </v-container>
    </template>
    <template v-if="authUser && session && authUser.id === session.user_id">
      <v-container fluid>
        <v-card class="mb-3">
          <v-toolbar dark dense color="primary">
            Instructions
            <v-spacer/>
            <v-btn icon @click="show_instruction =! show_instruction">
              <v-icon v-if="show_instruction">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar>
          <template v-if="show_instruction">
            <v-sheet v-if="session.mock.instruction" class="overflow-y-auto unselectable" max-height="500px">
              <v-card-text class="ql-editor" v-html="session.mock.instruction.body"></v-card-text>
            </v-sheet>
            <v-sheet v-else class="overflow-y-auto" max-height="500px">
              <v-card-text>No data available</v-card-text>
            </v-sheet>
          </template>
        </v-card>

        <template v-if="session.materials && session.materials.length > 0">
          <v-card class="mb-3">
            <v-toolbar dark dense color="primary">
              Materials
              <v-spacer/>
              <v-btn icon @click="show_materials =! show_materials">
                <v-icon v-if="show_materials">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
            </v-toolbar>
            <template v-if="show_materials">
              <!--             todo -->
            </template>
          </v-card>
        </template>

        <v-card>
          <v-toolbar dark dense color="primary">
            Your answers
          </v-toolbar>

          <v-data-table :items="answers"
                        :headers="answer_headers"
                        disable-pagination
                        hide-default-header
                        hide-default-footer
          >
            <template v-slot:item.type="{ value }">
              <v-icon>mdi-file</v-icon> {{ value }}
            </template>

            <template v-slot:item.preview="{ item }">
              <AnswerPreview :answer="item" width="150px"></AnswerPreview>
<!--              <template v-if="item.type === 'jpg'|| item.type === 'jpeg' || item.type === 'jpg'">-->
<!--                <v-img :src="`data:image/${item.type};base64,${item.file}`"  width="150px"/>-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                <embed :type="item.type" :src="`data:${item.type};base64,${item.file}`" width="150px">-->
<!--              </template>-->
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn color="error" icon @click="deleteAnswer(item)" v-if="!session.ready">
                <v-icon>mdi-delete</v-icon>
              </v-btn>              <!--            <v-icon class="mr-2" @click="openItem(item)">mdi-pencil</v-icon>-->
            </template>
          </v-data-table>

          <template v-if="!session.ready">
            <v-toolbar dense flat class="blur" outlined>
              At the moment, you can upload only pdf files
            </v-toolbar>
            <v-card-text>
              <!--              :accept="null"-->
<!--              :accept="'image/png, image/jpeg, image/bmp, application/pdf'"-->
              <file-uploader :upload_url="`api/user/sessions/${$route.params.session_id}/answers/file`"
                             :accept="'application/pdf'"
                             placeholder="Upload your answer"
                             @uploaded="pushNewAnswer"
              />
            </v-card-text>

            <v-divider/>
            <v-list-item>
              <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>
                  Make sure you upload all answers. After submitting your work, you will not be able to add or fix anything
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="primary" :disabled="answers.length === 0"
                       @click="mark_session_ready_dialog =!mark_session_ready_dialog">Submit for grading</v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-card>
      </v-container>

      <v-container fluid v-if="session.marked">
        <v-card class="unselectable">
          <template v-if="session.review">
            <v-toolbar dense color="blur">Review</v-toolbar>
            <v-sheet class="overflow-y-auto" min-height="200px" max-height="400px">
              <v-card-text class="ql-editor" v-html="session.review"></v-card-text>
            </v-sheet>
          </template>

          <v-toolbar dense elevation="0" color="blur">Marks<v-spacer/>
            Final mark <v-chip label color="primary px-2 mx-1">{{ session.final_mark}}</v-chip>
          </v-toolbar>
          <v-data-iterator :items="session.marks"
                           disable-pagination
                           disable-filtering
                           hide-default-footer
          >
            <template v-slot:default="props">
              <v-row>
                <v-col cols="12" md="6" v-for="(category, idx) in props.items" :key="idx">
                  <v-card flat tile>
                    <v-toolbar tile dense flat> {{ category.name }} <v-spacer/>
                      <v-chip label color="primary px-2 mx-1">{{ category.value }}</v-chip></v-toolbar>
                    <v-divider/>
                    <v-list-item v-for="(sub_category, i) in category.children" :key="i">
                      <v-list-item-content v-text="sub_category.name"/>
                      <v-list-item-action v-text="sub_category.value"/>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card>
      </v-container>

      <v-container fluid v-if="session.marked">
        <v-card v-if="session_response && session_response.marking_layout"
        :loading="session_response_loading">
          <embed :src="base64toBlob(session_response.marking_layout)" width="100%" height="600px">

<!--          <embed :src="`data:application/pdf;base64,${session_response.marking_layout}`"-->
<!--                 width="100%"-->
<!--                 height="500px"-->
<!--                 type="application/pdf">-->
        </v-card>

        <v-card class="my-3">
          <v-toolbar dense flat color="blur">Extra Tasks</v-toolbar>
          <v-card-text>
            <ol><li v-for="task in session.mock.additional_tasks" :key="task.id">{{ task.body }}</li></ol>
          </v-card-text>
          <v-divider/>
          <v-card-text>
            <p>
              Please note: We can not provide individual feedback for the above tasks, but you may check your answer
              against answers of other students in our Interview Case Studies Google Classroom, subject to your consent
              to share your answers with the  others in the same classroom under OSCEsmart Creative Commons License.
              In such a way, we jointly make a community database of answers! Submission of your answer with us
              shall amount to participation in the above scheme.
            </p>
            <p>
              In order to get access to other drafts, please  email your works to <a href="mailto:attendance.note.osce@gmail.com">
              attendance.note.osce@gmail.com
            </a>
            </p>
            <p>
              In order to obtain the access, please join our Client Interview Case Studies via
              <a href="https://classroom.google.com/c/MjczMzQzMjQzNDla?cjc=2vwgpnk">https://classroom.google.com/c/MjczMzQzMjQzNDla?cjc=2vwgpnk</a>
            </p>
          </v-card-text>
        </v-card>
      </v-container>

      <v-dialog v-model="mark_session_ready_dialog" max-width="500px">
        <v-card>
          <v-toolbar dense dark color="error">Submit for grading</v-toolbar>
          <v-card-text class="pt-3">
            Make sure you upload all answers. After submitting your work, you will not be able to add or fix anything
          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-space-between">
            <v-btn text @click="mark_session_ready_dialog =!mark_session_ready_dialog">Cancel</v-btn>
            <v-btn color="primary" @click="markSessionReadyForGrading">Send</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </section>
</template>

<script>

import PDFEditor from "@/components/pdf-editor/PDFEditor";
import AnswerPreview from "@/views/classroom/AnswerPreview";
import {base64StringToBlob, createObjectURL} from "blob-util";
export default {
  components: {PDFEditor, AnswerPreview},
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({

    show_instruction: true,
    show_materials: true,
    answers: [],
    answer_headers: [
      { text: 'Preview', value: 'preview', sortable: false },
      { text: 'Type', value: 'type' },
      { text: 'File', value: 'name' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],


    files: [],
    rules: [
      files => !files || !files.some(file => file.size > 2_097_152) || 'File size should be less than 2 MB!'
    ],
    mark_session_ready_dialog: false,

    api_errors: [],


    // url: 'http://192.168.1.97:8000/storage/test.pdf', // a PDF
    url: 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf', // a PDF
    scale: 1,

    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["blockquote", "code-block"],
      ["link", "image", "formula"],
    ],
    stepper: 1,
    mark_options: [
      {text: 'Good', value: 'good'},
      {text: 'Check', value: 'check'},
      {text: 'Plus', value: 'plus'},
      {text: '50/50', value: '50_50'},
      {text: 'Minus', value: 'minus'},
    ],

    session_response: null,
    session_response_loading: false,
  }),
  mounted() {
    this.loadAnswers()
    this.loadSessionResponse()
    // this.print()
    // this.generatePdf()
    // this.modifyPdf()
  },
  methods: {
    loadAnswers() {
      this.axios.get(`api/user/sessions/${this.$route.params.session_id}/answers`)
          .then(({data}) => { this.answers = data.data })
    },
    generateSessionResponse() {
      this.app_loading = true
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}/response`)
          .then(({data}) => { this.session_response = data.data })
          .catch(errors => {console.log(errors)})
          .then(() => {this.app_loading = false;})
    },
    loadSessionResponse() {
      this.session_response_loading = true
      this.axios.get(`api/user/sessions/${this.$route.params.session_id}/response`)
          .then(({data}) => {
            this.session_response = data.data
            this.session_response_loading = false
          })
    },
    updateSessionResponse(payload) {
      this.session_response = payload
    },
    pushNewAnswer(answer) {
      this.answers.push(answer)
    },
    deleteAnswer(item) {
      this.app_loading = true
      this.axios.delete(`api/user/sessions/${this.$route.params.session_id}/answers/${item.id}`)
          .then(() => {
            this.loadAnswers()
            this.app_loading = false
          })
    },
    markSessionReadyForGrading() {
      this.$emit('sessionReady')
      this.mark_session_ready_dialog = !this.mark_session_ready_dialog
    },
    toBlobUrl(base64str) {
      const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }

      const contentType = 'application/pdf';

      const blob = b64toBlob(base64str, contentType);
      return URL.createObjectURL(blob);
    },
    base64toBlob(base64Data) {
      const blob = base64StringToBlob(base64Data, 'application/pdf');
      return createObjectURL(blob)
    },



  }
}
</script>
